import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { APIProvider } from '@vis.gl/react-google-maps';
import { trpc, trpcClient } from './lib/trpc';
import { initSentry } from './lib/sentry';
import App from './App';
import { ErrorBoundary } from './ErrorBoundary';
import './index.css';

// Initialize Sentry as early as possible (no-op if DSN not configured)
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TRPCProvider = trpc.Provider as any;

const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <APIProvider 
        apiKey={googleMapsApiKey}
        libraries={['places', 'geocoding', 'marker']}
      >
        <TRPCProvider client={trpcClient} queryClient={queryClient}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </TRPCProvider>
      </APIProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

